// extracted by mini-css-extract-plugin
export default {"controls":"URdEJ","desktopControls":"lGvLJ","control":"WZQ1a"};